import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { injectFeedOperatorHintsQuery } from 'src/app/api/queries/feed.queries';
import { FeedOperatorHint } from '../../../services/feed.service';
import { NomObjectTypes } from '../../../constants';

@Component({
  selector: 'app-feed-query-hints-popup',
  templateUrl: './feed-query-hints-popup.component.html',
  styleUrl: './feed-query-hints-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedQueryHintsPopupComponent {
  @Input() objectTypeId: NomObjectTypes;

  // Set in ngOnInit - the input isn't available in a field initializer.
  private readonly operatorsObjectTypeId = signal<number | null>(null);
  private readonly feedOperatorHintsQuery = injectFeedOperatorHintsQuery(
    this.operatorsObjectTypeId,
  );

  feedOperators$: Observable<Array<FeedOperatorHint>> = toObservable(
    computed(() => this.feedOperatorHintsQuery.data() ?? []),
  );

  @Output() close = new EventEmitter<void>();
  @Output() hintSelected = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.objectTypeId) {
      this.operatorsObjectTypeId.set(this.objectTypeId);
    }
  }

  onCloseClick() {
    this.close.emit();
  }

  addOperator(operatorName: any) {
    this.hintSelected.emit(operatorName);
  }
}
